import { HorizontalContainer, VerticalContainer } from '@american-autonomy/ag-ui';

import NavigationBoldText from 'components/text/NavigationBoldText';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const NavigationItem: FunctionComponent<Props> = ({
    className = '',
    icon,
    isActive = false,
    isOpen,
    label,
    onClick,
    testId = TEST_ID
}) => {
    const activeStyles = isActive ? styles.active : '';
    const closedStyles = isOpen ? '' : styles.closed;

    return (
        <HorizontalContainer
            className={`${activeStyles} ${className} ${styles.navigationItem}`}
            onClick={onClick}
            testId={testId}>
            <VerticalContainer className={`${closedStyles} ${styles.navigationStatusBar}`} />

            <VerticalContainer className={styles.verticalContainer}>
                {icon}

                <NavigationBoldText className={styles.navigationBoldText}>
                    {label}
                </NavigationBoldText>
            </VerticalContainer>
        </HorizontalContainer>
    );
};

export default NavigationItem;
